import { Box, Card, CardContent } from '@mui/material';
import { refToDataUrl, ShareBottom, ShareTop } from 'components/common/ShareControls';
import { EndContent } from 'components/EndContent';
import { end_content } from 'components/quote/data_uris';
import TextContent from 'components/TextContent';
import { getContentStorageUrl, getWebAppAssetPath, isAdmin, toDataUrl } from 'helpers';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, ContentType, Rhyme } from 'types';
import { GoldenRhyme } from './GoldenRhyme';

interface Props {
	rhyme?: Rhyme;
	locale: string;
	isEmbed?: boolean;

	forShare?: boolean;
	onImgComplete?: (dataUrl: any) => void;
}

export const Component = (props: Props) => {
	let { rhyme, locale, isEmbed, forShare, onImgComplete } = props;
	let rhymeRef = React.useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (forShare) {
			refToDataUrl(rhymeRef).then((dataUrl) => {
				if (onImgComplete) {
					onImgComplete(dataUrl);
				}
			});
		}
	}, [forShare, onImgComplete]);

	let text = rhyme?.text[locale] || rhyme?.text.hi || rhyme?.text.en;
	let textLocale = rhyme?.text[locale] ? locale : rhyme?.text.hi ? 'hi' : 'en';

	let context;
	let contextLocale;
	if (rhyme?.context) {
		context = rhyme?.context[locale];
		contextLocale = rhyme?.context[locale] ? locale : rhyme?.context.hi ? 'hi' : 'en';
	}

	let loading = !rhyme ? (
		<Card style={{ marginTop: 8 }} elevation={0}>
			<CardContent style={{ paddingTop: 0, paddingBottom: 0 }}>Content doesn not exist!!</CardContent>
		</Card>
	) : null;

	return rhyme ? (
		<Box ref={rhymeRef} sx={props.forShare ? { minWidth: 320 } : {}}>
			{props.forShare && <ShareTop subtitle="Scroll of Wisdom" />}
			<Card style={{ marginTop: props.forShare ? 1 : 8, borderRadius: 0 }} elevation={0}>
				{context ? (
					<CardContent style={{ paddingTop: 0, paddingBottom: 0 }}>
						<TextContent alignRhymes={true} locale={contextLocale}>
							<span
								dangerouslySetInnerHTML={{
									__html: context,
								}}
							/>
						</TextContent>
					</CardContent>
				) : null}
				<GoldenRhyme rhyme={rhyme?.rhyme ?? ''} />
				<CardContent style={{ paddingTop: 0, paddingBottom: 0 }}>
					<TextContent alignRhymes={true} locale={textLocale}>
						<span
							dangerouslySetInnerHTML={{
								__html: text ?? '',
							}}
						/>
					</TextContent>
				</CardContent>
				{isEmbed ? null : <img src={end_content} style={{ width: '50%', display: 'block', margin: '24px auto' }} alt="" />}
			</Card>
			{props.forShare && <ShareBottom locale={textLocale} />}
		</Box>
	) : (
		loading
	);
};

function mapStateToProps(state: ApplicationState, props: { id: string; lang?: string }) {
	let rhyme: Rhyme | undefined = state.dataState.rhymes.byId[props.id];

	let admin = isAdmin(state.userState.userStore.user, state.userState.userStore.userData);
	let showAll = admin && state.userState.userStore.userData?.settings && state.userState.userStore.userData?.settings['admin.records'];

	if (
		!showAll &&
		rhyme &&
		(rhyme.active === false || rhyme.publishTime.seconds > new Date().getTime() / 1000 || rhyme.expireTime.seconds <= new Date().getTime() / 1000)
	) {
		rhyme = undefined;
	}

	return {
		rhyme,
		locale: props.lang ?? state.uxState.locale,
	};
}

export const RhymePageContent = connect(mapStateToProps)(Component);
